import { writable } from 'svelte-local-storage-store';
export const darkModeStore = writable('darkMode', '');
darkModeStore.subscribe((darkMode) => {
    if (darkMode) {
        document.documentElement.classList.add('dark');
        return;
    }
    document.documentElement.classList.remove('dark');
});
